import React from 'react'
import { postgresDateToIndonesia } from 'utils/MyUtils'


export default function DateView(props) {
    const val = props.val
    var viewval = ""
    viewval = postgresDateToIndonesia(val)

    return (
        <>{viewval}</>
    )
}
